import React, { useState } from 'react';
import { Button } from 'antd';
import { CheckOutlined, CloseOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import alertBlue from 'assets/images/alert-blue.svg';
import iconErrorSvg from 'assets/images/alert-circle-red.svg';

interface Props {
  state: 'complete' | 'no-guarantor' | 'next-step' | 'incomplete' | 'verify' | 'error';
  className: string;
  onChange?: Function;
  isExpand?: boolean;
  disabled?: boolean;
  disabledExpand?: boolean;
}

const TagOwnerState = ({ state, className, onChange, isExpand, disabled, disabledExpand }: Props) => {
  
  const changeExpand = () => {
    if(onChange && !disabled) onChange(!isExpand);
  }

  return (
    <div className={`${className}`}>
      <div 
        style={disabledExpand? { width: '365px' }: undefined}
        className={`tag-owner-content tag-owner-content-${state} ${disabled && `tag-owner-content-${state}-disabled`}`}
      >
        {state === 'complete' && (
          <>
            <b className={`approved`}>
              <CheckOutlined /> Profile complete
            </b>
            {!disabled && <b>|</b>}
          </>
        )}
        {state === 'next-step' && (
          <>
            <b><CloseOutlined /> No guarantor profile</b>
            <span className='tag-description'>You’ll make a profile in the next step</span>
          </>
        )}
        {state === 'error' && (
          <>
            <b><img src={iconErrorSvg} alt="upload" className="upload" /> Profile error</b>
            <span className='tag-description'>Update and resubmit</span>
            <b>|</b>
          </>
        )}
        {state === 'incomplete' && (
          <>
            <b><img src={alertBlue} width="15"/> Complete guarantor information</b>
          </>
        )}
        {state === 'verify' && (
          <>
            <b><img src={alertBlue} width="15"/> Reconfirm guarantor information</b>
          </>
        )}
        {state === 'no-guarantor' && (
          <>
            <b>No profile needed</b>
            <span>Ownership is less than 20%</span>
          </>
        )}

        { disabledExpand && state === 'complete' && 
          <span className='message-status'>You can edit this profile in the next step.</span>
        }

        {!disabledExpand && !disabled && (state === 'complete' || state === 'incomplete' || state === 'verify' || state === 'error') && 
          <Button
            type="link"
            style={{ padding: 0 }}
            onClick={changeExpand}
          >
            {!isExpand && (state !== 'incomplete' && state !== 'verify') && 'View profile'}
            {isExpand && (state !== 'incomplete' && state !== 'verify') && 'Close profile'}
            {!isExpand && <DownOutlined />}
            {isExpand && <UpOutlined />}
          </Button>
        }
      </div>
    </div>
  );
};
export default TagOwnerState;
